import React                 from 'react';
import Parse                 from 'parse';
import { Route, IndexRoute } from 'react-router';
import App                   from './components/app';
import Home                  from './components/home';
import Stats                 from './components/stats';
import Stats2                from './components/stats-2';
import Register              from './components/register';
import About                 from './components/about';
import Login                 from './components/login';
import Logout                from './components/logout';
import ConnectStripeFail     from './components/connect-stripe-fail';
import ConnectStripeSuccess  from './components/connect-stripe-success';
import AcctCreation          from './components/acct-creation';
import Terms                 from './components/terms';
import Privacy               from './components/privacy';
import Agreement             from './components/agreement';
import Dashboard             from './components/dashboard';


function redirectToLogin(nextState, replace, callback) {
    let currentUser = Parse.User.current();
    if (!currentUser) {
        callback();
        replace({
            pathname: '/login',
            state: { nextPathname: nextState.location.pathname }
        });
    } else if(currentUser) {

        currentUser.fetch()
        .then(() => {

            //currentUser.set("emailVerified", true);

            if (!currentUser.get("emailVerified")) {
                replace({
                    pathname : '/register',
                    state    : {emailVerified : false}
                })
            } else if(!currentUser.get("bizId")) {
                replace({
                    pathname : '/register',
                    state    : {
                        emailVerified : true,
                        businessAdded : false
                    }
                })
            }
        })
        .then(
            () => {
                callback();
            },
            (error) => {
                console.log("Error"+JSON.stringify(error));
                callback(error);
            }
        );

    }

}

function redirectToDashboard(nextState, replace, callback) {

    let currentUser = Parse.User.current();

    if(currentUser) {

        currentUser.fetch()
        .then(() => {

            //currentUser.set("emailVerified", true);

            if(!currentUser.get("emailVerified")) {
                replace({
                    pathname : '/register',
                    state    : {emailVerified : false}
                })
            } else if(!currentUser.get("bizId")) {
                replace({
                    pathname : '/register',
                    state    : {
                        emailVerified : true,
                        businessAdded : false
                    }
                })
            }
        }).then(
            () => {
                callback();
            },
            (error) => {
                console.log("Error"+JSON.stringify(error));
                callback(error);
            }
        );

    }else{
         callback();
    }
}

function logoutSession(nextState, replace){

        Parse.User.logOut().then(
            () => {
                replace('/');
            },
            () => {
                replace('/dashboard')
            }
        );

}

module.exports = (
       <Route path="/" component={App}>
           <IndexRoute component={Login} />
           <Route path="/stats" component={Stats}/>
           <Route path="/stats2" component={Stats2}/>
           <Route path="/register" component={Register}/>
           <Route path="/about" component={About}/>
           <Route path="/login" component={Login}/>
           <Route path="/logout" component={Logout} onEnter={logoutSession}/>
           <Route path="/dashboard" component={Dashboard} onEnter={redirectToLogin}/>
           <Route path="/testLink1" component={ConnectStripeFail}/>
           <Route path="/testLink2" component={AcctCreation}/>
           <Route path="/testLink3" component={ConnectStripeSuccess}/>
       </Route>
);

// Old route backup
//module.exports = (
       //<Route path="/" component={App}>
           //<IndexRoute component={Home} onEnter={redirectToDashboard}/>
           //<Route path="/stats" component={Stats}/>
           //<Route path="/stats2" component={Stats2}/>
           //<Route path="/register" component={Register}/>
           //<Route path="/about" component={About}/>
           //<Route path="/login" component={Login}/>
           //<Route path="/logout" component={Logout} onEnter={logoutSession}/>
           //<Route path="/dashboard" component={Dashboard} onEnter={redirectToLogin}/>
           //<Route path="/testLink1" component={ConnectStripeFail}/>
           //<Route path="/testLink2" component={AcctCreation}/>
           //<Route path="/testLink3" component={ConnectStripeSuccess}/>
           //<Route path="/terms" component={Terms}/>
           //<Route path="/privacy" component={Privacy}/>
           //<Route path="/agreement" component={Agreement}/>
       //</Route>
//);



// WEBPACK FOOTER //
// src/routes.js